// ── SPCore announcement bar ──
(function () {
  function boot() {
    document.querySelectorAll('[data-sp-announcement]').forEach(function (el) {
      if (!el.spAnnouncement) el.spAnnouncement = new SPAnnouncement(el);
    });
  }

  class SPAnnouncement {
    constructor(root) {
      this.root = root;
      this.slides = Array.from(root.querySelectorAll('[data-slide]'));
      this.index = 0;
      this.speed = parseInt(root.dataset.speed, 10) || 5000;
      this.autoplay = root.dataset.autoplay === 'true' && !(SPCore.config && SPCore.config.motionReduced);
      this.init();
    }

    init() {
      if (this.slides.length < 2 || !this.autoplay) return;
      this.root.addEventListener('mouseenter', () => this.stop());
      this.root.addEventListener('mouseleave', () => this.start());
      this.root.addEventListener('focusin', () => this.stop());
      this.root.addEventListener('focusout', () => this.start());
      this.start();
    }

    go(i) {
      const n = this.slides.length;
      this.index = ((i % n) + n) % n;
      this.slides.forEach((slide, si) => slide.classList.toggle('is-active', si === this.index));
    }

    start() {
      if (!this.timer && this.slides.length > 1) this.timer = setInterval(() => this.go(this.index + 1), this.speed);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  if (window.SPCore) SPCore.DOMready(boot);
  else document.addEventListener('DOMContentLoaded', boot);
})();
